import Axios from 'axios';
import { v4 as idv4 } from 'uuid';

import { APIgetFileCredentials } from '@/features/auth';

const validate = (file: any, config: any) => {
    if (!config) {
        return;
    }
    if (config.image) {
        if (!file.type.startsWith('image')) {
            throw new Error('You must upload an image');
        }
    }
    if (config.storage.maxSizeInBytes && file.size > config.storage.maxSizeInBytes) {
        throw new Error(`File size must be less than ${config.storage.maxSizeInBytes} bytes`);
    }
    const extension = extractExtensionFrom(file.name);

    if (config.formats && !config.formats.includes(extension)) {
        throw new Error(`File format must be one of ${config.formats.join(', ')}`);
    }
};

const upload = async (file: any, config: any, tenantId: string) => {
    try {
        validate(file, config);
    } catch (error) {
        return Promise.reject(error);
    }
    const extension = extractExtensionFrom(file.name);
    const id = idv4();
    const filename = `${id}.${extension}`;

    const { uploadCredentials, downloadUrl, privateUrl } = await APIgetFileCredentials(tenantId, filename, config.storage.id);

    await uploadToServer(file, uploadCredentials);

    return {
        id: id,
        name: file.name,
        sizeInBytes: file.size,
        publicUrl: uploadCredentials && uploadCredentials.publicUrl ? uploadCredentials.publicUrl : null,
        privateUrl,
        downloadUrl,
        new: true
    };
};

const uploadToServer = (file: any, uploadCredentials: any) => {
    try {
        const url = uploadCredentials.url;
        const formData = new FormData();

        for (const [key, value] of Object.entries(uploadCredentials.fields || {})) {
            formData.append(key, value as string);
        }
        formData.append('file', file);
        return Axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};

const extractExtensionFrom = (filename: string) => {
    if (!filename) {
        return null;
    }
    const regex = /(?:\.([^.]+))?$/;
    const exec = regex.exec(filename);
    if (!exec) {
        return null;
    }
    return exec[1];
};

export const fileUploader = {
    upload
};
